import axios from "../axios-interceptor.js"
import { successResponse, errorResponse } from "./SpaceServices.js";

let tenantId = localStorage.getItem("tenantId")
const BACKEND_API = process.env.REACT_APP_BACKEND_API
const AUTH_BACKEND_API = process.env.AUTH_BACKEND_API

export const getSpaceAllFormsByWorkflowId = async (workflowId, userInfo = {}) => {

  let responseObj = { status: "", message: "", data: [] };

  try {
    let res = await axios({
      method: "GET",
      url: `${BACKEND_API}/form?workflowId=${workflowId}`,
      headers: {
        tenantId: tenantId,
      },
    });
    responseObj = successResponse(res.data, responseObj, true, res.status)
  }
  catch (error) {
    responseObj = errorResponse(error, responseObj, false)
  }
  return responseObj
}

export const getSpaceAllPublicFormsByWorkflowId = async (workflowId, shareToken = {}) => {

  let responseObj = { status: "", message: "", data: [] };

  try {
    let res = await axios({
      method: "GET",
      url: `${BACKEND_API}/api/public/form/${workflowId}/${shareToken}`,
      headers: {
        tenantId: tenantId,
      },
    });
    responseObj = successResponse(res.data, responseObj, true, res.status)
  }
  catch (error) {
    responseObj = errorResponse(error, responseObj, false)
  }
  return responseObj
}

export const submitRequestForm = async (postData) => {

  let responseObj = { status: "", message: "", data: {} };

  try {
    let res = await axios({
      method: postData.requestId ? "PUT" : "POST",
      url: `${BACKEND_API}/request`,
      data: postData,
      headers: {
        tenantId: tenantId,
      },
    });
    responseObj = successResponse(res.data, responseObj, true, res.status)
  }
  catch (error) {
    responseObj = errorResponse(error, responseObj, false)
  }
  return responseObj
}

export const getPreviousDataByValue = async (keyId, value, spaceId, requestId) => {
  let responseObj = { status: "", message: "", data: null };
  try {
    const keyToSearch = `${keyId}:${value}`
    const headers = { tenantId: tenantId }
    if (spaceId) headers.spaceId = spaceId
    let res = await axios({
      method: "GET",
      url: `${BACKEND_API}/request/value?keyToSearch=${encodeURIComponent(keyToSearch)}&requestId=${requestId}`,
      headers,
    });
    responseObj = successResponse(res.data, responseObj, false, res.status)
  }
  catch (error) {
    responseObj = errorResponse(error, responseObj, false)
  }
  return responseObj
}

export const getPublicPreviousDataByValue = async (keyId, value, requestId, spaceId, shareToken) => {
  let responseObj = { status: "", message: "", data: null };
  try {
    // Public endpoint expects the keyToSearch wrapped in double quotes.
    const keyToSearch = `"${keyId}:${value}"`
    const headers = {}
    if (spaceId) headers.spaceId = spaceId
    let res = await axios({
      method: "GET",
      url: `${BACKEND_API}/api/public/form/request/value/${encodeURIComponent(shareToken)}?keyToSearch=${encodeURIComponent(keyToSearch)}&requestId=${requestId}`,
      headers,
    });
    responseObj = successResponse(res.data, responseObj, false, res.status)
  }
  catch (error) {
    responseObj = errorResponse(error, responseObj, false)
  }
  return responseObj
}

export const getRequests = async (spaceId, workflowId, pageNumber = 1, pageSize = 50, viewId = null) => {
  let responseObj = { status: "", message: "", data: [] };
  // let api = `${BACKEND_API}/request?spaceId=${spaceId}&workflowId=${workflowId}&pageNumber=${pageNumber}&pageSize=${pageSize}`
  let api = `${BACKEND_API}/requests?spaceId=${spaceId}&pageNumber=${pageNumber}&pageSize=${pageSize}`
  if (viewId) {
    api += `&viewId=${viewId}`
  }

  try {
    let res = await axios({
      method: "GET",
      url: api,
      headers: {
        tenantId: tenantId,
      },
    });
    responseObj = successResponse(res.data, responseObj, true, res.status)
  }
  catch (error) {
    responseObj = errorResponse(error, responseObj, false)
  }
  return responseObj
}

export const getAdvanceSearchDocuments = async (filters, spaceId, pageNumber = 1, pageSize = 10) => {
  let responseObj = { status: "", message: "", data: [] };
  let api = `${BACKEND_API}/requests?spaceId=${spaceId}&pageNumber=${pageNumber}&pageSize=${pageSize}`
  // if (viewId) {
  //   api += `&viewId=${viewId}`
  // }

  try {
    let res = await axios({
      method: "POST",
      url: api,
      headers: {
        tenantId: tenantId,
      },
      data: filters
    });
    responseObj = successResponse(res.data, responseObj, true, res.status)
  }
  catch (error) {
    responseObj = errorResponse(error, responseObj, false)
  }
  return responseObj
}

export const getSingleRequest = async (requestId) => {
  let responseObj = { status: "", message: "", data: [] };

  try {
    let res = await axios({
      method: "GET",
      url: `${BACKEND_API}/request/${requestId}`,
      headers: {
        tenantId: tenantId,
      },
    });
    responseObj = successResponse(res.data, responseObj, true, res.status)
  }
  catch (error) {
    responseObj = errorResponse(error, responseObj, false)
  }
  return responseObj
}


export const submitComment = async (postData, method) => {
  let responseObj = { status: "", message: "", data: [] };

  try {
    let res = await axios({
      method: method,
      url: `${BACKEND_API}/comment`,
      data: postData,
      headers: {
        tenantId: tenantId,
      },
    });
    responseObj = successResponse(res.data, responseObj, true, res.status)
  }
  catch (error) {
    responseObj = errorResponse(error, responseObj, false)
  }
  return responseObj
}

export const getRequestComment = async (requestId, signal) => {
  let responseObj = { status: "", message: "", data: [] };

  try {
    let res = await axios({
      method: "GET",
      url: `${BACKEND_API}/comment/${requestId}`,
      signal: signal,
      headers: {
        tenantId: tenantId,
      },
    });
    responseObj = successResponse(res.data, responseObj, true, res.status)
  }
  catch (error) {
    responseObj = errorResponse(error, responseObj, false)
  }
  return responseObj
}

export const getRequestsByApprovers = async (userEmail) => {
  let responseObj = { status: "", message: "", data: [] };

  try {
    let res = await axios({
      method: "GET",
      url: `${BACKEND_API}/request/approvers`,
      headers: {
        tenantId: tenantId,
      },
    });
    responseObj = successResponse(res.data, responseObj, true, res.status)
  }
  catch (error) {
    responseObj = errorResponse(error, responseObj, false)
  }
  return responseObj
}

export const getAllSpacesRequests = async (userEmail) => {
  let responseObj = { status: "", message: "", data: { totalCount: 0, requests: [] } };

  try {
    let res = await axios({
      method: "GET",
      url: `${BACKEND_API}/request-by-user-email?pageNumber=1&pageSize=100`,
      headers: {
        tenantId: tenantId,
      },
    });
    responseObj = successResponse(res.data, responseObj, true, res.status)
  }
  catch (error) {
    responseObj = errorResponse(error, responseObj, false)
  }
  return responseObj
}


export const getSpaceViews = async (spaceId, userId) => {
  let responseObj = { status: "", message: "", data: [] }
  try {
    let res = await axios({
      method: "GET",
      url: `${BACKEND_API}/view?spaceId=${spaceId}`,
      headers: {
        tenantId: tenantId,
        userId: userId
      },
    });
    responseObj = successResponse(res.data, responseObj, true, res.status)
  }
  catch (error) {
    responseObj = errorResponse(error, responseObj, true)
  }
  return responseObj

}

export const getSingleView = async (spaceId, viewId, userId) => {
  let responseObj = { status: "", message: "", data: null }
  try {
    let res = await axios({
      method: "GET",
      url: `${BACKEND_API}/view/${viewId}?spaceId=${spaceId}`,
      headers: {
        tenantId: tenantId,
        userId: userId
      },
    });
    responseObj = successResponse(res.data, responseObj, true, res.status)
  }
  catch (error) {
    responseObj = errorResponse(error, responseObj, false)
  }
  return responseObj
}

// Persist the space's default view (List / Kanban / Graph) for the current user.
// Pass an empty string as selectedView to clear the default.
export const updateSelectedView = async (spaceId, selectedView, userId) => {
  let responseObj = { status: "", message: "", data: {} }
  try {
    let res = await axios({
      method: "PUT",
      url: `${BACKEND_API}/selectedView`,
      data: { spaceId, selectedView },
      headers: {
        tenantId: tenantId,
        userId: userId
      },
    });
    responseObj = successResponse(res.data, responseObj, false, res.status)
  }
  catch (error) {
    responseObj = errorResponse(error, responseObj, false)
  }
  return responseObj
}

export const deleteSpaceView = async (view, spaceId, userId) => {
  let responseObj = { status: "", message: "", data: [] }
  try {
    let resp = await axios({
      method: "DELETE",
      url: `${BACKEND_API}/view/${view.viewId}?spaceId=${spaceId}`,
      data: view,
      headers: {
        userId: userId,
        tenantId: tenantId
      }
    })
    responseObj = successResponse(resp.data, responseObj, true, resp.status)
  }
  catch (error) {
    responseObj = errorResponse(error, responseObj, false)
  }
  return responseObj
}

export const downloadRequestXml = async (requestId, userId) => {
  let responseObj = { status: "", message: "", data: [] }
  try {
    let resp = await axios({
      method: "GET",
      url: `${BACKEND_API}/request/${requestId}/xml`,
      headers: {
        userId: userId,
        tenantId: tenantId
      }
    })
    responseObj = { data: resp.data, status: resp.status }
  }
  catch (error) {
    responseObj = errorResponse(error, responseObj, false)
  }
  return responseObj
}

// Fetch full dataset for Graphical mode using total row count as pageSize
export const getRequestsForGraph = async (spaceId, workflowId, totalRows = 0) => {
  let responseObj = { status: "", message: "", data: [] };

  try {
    const size = Math.max(1, Number(totalRows) || 50);
    let res = await axios({
      method: "GET",
      url: `${BACKEND_API}/request?spaceId=${spaceId}&workflowId=${workflowId}&pageNumber=1&pageSize=${size}`,
      headers: {
        tenantId: tenantId,
      },
    });
    responseObj = successResponse(res.data, responseObj, true, res.status)
  }
  catch (error) {
    responseObj = errorResponse(error, responseObj, false)
  }
  return responseObj
}

export const getDuplicateCheckList = async (postObj) => {
  let responseObj = { status: "", message: "", data: [] };
  try {
    let response = await axios({
      method: "POST",
      url: `https://sap-backend-dot-saltoris-elit.el.r.appspot.com/api/v1/sap/check-duplicate`,
      data: postObj
    })
    responseObj = successResponse(response.data, responseObj, true, response.status)
    responseObj.message = "Duplicate check completed"
    responseObj.data = response.data?.duplicates;
    responseObj.status = response.status
  }
  catch (error) {
    responseObj = errorResponse(error, responseObj, false)
  }
  return responseObj
}

/**
 * Mass update multiple requests with workflow data
 * @param {string} spaceId - The space ID
 * @param {Array} updates - Array of update objects containing requestId, value, and workflow data
 * @returns {Object} Response object with status, message, and data
 */
export const massUpdateRequests = async (spaceId, updates) => {
  let responseObj = { status: "", message: "", data: [] };
  try {
    let response = await axios({
      method: "POST",
      url: `${BACKEND_API}/request/mass-update?spaceId=${spaceId}`,
      data: updates,
      headers: {
        tenantId: tenantId,
      },
    })
    responseObj = successResponse(response.data, responseObj, true, response.status)
    responseObj.message = "Mass update completed successfully"
  }
  catch (error) {
    responseObj = errorResponse(error, responseObj, false)
  }
  return responseObj
}

// Re-sync a request's master data (e.g. re-run the new-store-locations master update).
export const updateRequestMaster = async (requestId) => {
  let responseObj = { status: "", message: "", data: {} };
  try {
    let response = await axios({
      method: "PUT",
      url: `${BACKEND_API}/request/update-master?requestId=${requestId}`,
      headers: {
        tenantId: tenantId,
      },
    })
    responseObj = successResponse(response.data, responseObj, false, response.status)
  }
  catch (error) {
    responseObj = errorResponse(error, responseObj, false)
  }
  return responseObj
}

// Add Collaborator
export const addCollaboratorInSpace = async (postData) => {
let responseObj = { status: "", message: "", data: [] };
  try {
    let response = await axios({
      method: "PUT",
      url: `${BACKEND_API}/add-collaborator`,
      data: postData,
      headers: {
        tenantId: tenantId,
      },
    })
    responseObj = successResponse(response.data, responseObj, true, response.status)
    responseObj.message = "Mass update completed successfully"
  }
  catch (error) {
    responseObj = errorResponse(error, responseObj, false)
  }
  return responseObj

  
}